// extracted by mini-css-extract-plugin
export var buttonContainer = "_9o-1";
export var fontSizeSelect = "_9o-3";
export var formatSelect = "_9o-2";
export var formats = "_9o-4";
export var hidden = "_9o-5";
export var icon = "_9o-6";
export var select = "_9o-0";